import { memo } from 'react';
import { useWidthCheck } from '../../../hooks';
import { MOBILE_WIDTH } from '../../../settings';
import { Crumb } from '@components/tailwind/Breadcrumbs';
import { useLifestyleHeaderOverride } from '@features/pdp/hooks';
import cx from '@utils/cx.util';

type TProps = {
  crumbs: Crumb[];
};

const LifestyleHeader = ({ crumbs }: TProps) => {
  const isMobView = useWidthCheck(MOBILE_WIDTH);
  const lifestyleHeader = useLifestyleHeaderOverride();

  if (!lifestyleHeader?.title || !lifestyleHeader?.image?.desktop) return null;

  return (
    <div
      className={cx(
        'tw-relative tw-mx-auto tw-flex tw-h-[250px] tw-max-w-[1920px] tw-justify-center tw-from-black tw-px-4 tw-py-3 lg:tw-h-[550px] lg:tw-py-5',
        lifestyleHeader.containerClassName
      )}>
      {lifestyleHeader.video ? (
        <video
          controls={false}
          title='Featured Video'
          height={isMobView ? 'auto' : '100%'}
          width={isMobView ? '100%' : 'auto'}
          autoPlay
          playsInline
          loop
          muted
          className='tw-absolute tw-inset-0 tw-z-0 tw-h-full tw-w-full tw-object-cover tw-object-center'
          poster={(isMobView ? lifestyleHeader.image.mobile : lifestyleHeader.image.desktop) ?? null}>
          <source
            src={
              Boolean(lifestyleHeader.videoMob) && isMobView
                ? lifestyleHeader.videoMob
                : lifestyleHeader.video
            }
            type='video/mp4'
          />
        </video>
      ) : (
        <img
          className='tw-absolute tw-inset-0 tw-z-0 tw-h-full tw-w-full tw-object-cover tw-object-center'
          src={isMobView ? lifestyleHeader.image.mobile : lifestyleHeader.image.desktop}
        />
      )}

      <span className='tw-absolute tw-inset-0 tw-z-10 tw-bg-gradient-to-b tw-from-[#00000076]'></span>

      <div
        className={cx(
          'tw-relative tw-z-20 tw-flex tw-items-center tw-text-center',
          lifestyleHeader.titleContainerClassName
        )}>
        <h1
          className={cx(
            'tw-font-screamer tw-text-[64px] tw-font-bold tw-uppercase tw-leading-[64px] tw-text-white tw-drop-shadow-md lg:tw-text-[128px] lg:tw-leading-[128px]',
            lifestyleHeader.titleClassName
          )}>
          {lifestyleHeader.title}
        </h1>
      </div>
    </div>
  );
};

export default memo(LifestyleHeader);
